import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AuthService from '../../services/AuthService';
import '../../styles/changebranch.scss';

const ChangeBranch = ({ branches }) => {
  const branchOptions = useSelector(state => state.app.branchOptions);

  if (!branches) {
    branches = branchOptions;
  }

  const switchBranch = branchId => {
    AuthService.switchBranch(branchId).then(() => {
      location.reload(false);
    });
  };

  const renderBranches = () => {
    const items = [];
    let headerID = 0;

    for (const companyName of Object.keys(branches).sort()) {
      // eslint-disable-line
      // render branches within each company in sorted order
      branches[companyName].sort((a, b) => {
        return a.name.localeCompare(b.name);
      });

      // sort by "sortNum" associated with branch
      branches[companyName].sort((a, b) => {
        if (a.sortNum === b.sortNum) {
          return 0;
        }

        if (a.sortNum === 0) {
          return 1;
        }

        if (b.sortNum === 0) {
          return -1;
        }

        return a.sortNum > b.sortNum ? 1 : -1;
      });

      items.push(
        <div key={`company-${headerID}`} className="company">
          {companyName}
        </div>
      );

      headerID++;

      for (const branch of branches[companyName]) {
        // eslint-disable-line
        items.push(
          <div
            key={`branch-${branch.id}`}
            onClick={() => switchBranch(branch.id)}
            className={`branch ${branch.active && 'active'}`}
          >
            {branch.name}
            {branch.active && (
              <div className="current">
                <i className="zmdi zmdi-check" />
              </div>
            )}
          </div>
        );
      }
    }

    return items;
  };

  return (
    <div className="change-branch">
      <div className="branch-wrapper">{renderBranches()}</div>
    </div>
  );
};

ChangeBranch.propTypes = {
  branches: PropTypes.object,
};

export default ChangeBranch;
